import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_BASE_URL from "../constent";

// 1. Fetch all Main European Websites
export const fetchMainEuropeanWebsites = createAsyncThunk(
  "websitesEuropean/fetchMainEuropeanWebsites",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/area/67dfef98100f542a2c700c08`
      );
      let areaData = response.data.data;
      if (areaData.category.length > 0) {
        const categoryDetails = await Promise.all(
          areaData.category.map(async (item) => {
            if (typeof item.category === "string") {
              const categoryResponse = await axios.get(
                `${API_BASE_URL}/category/${item.category}`
              );
              return { ...item, category: categoryResponse.data };
            }
            return item;
          })
        );

        // Replace the superCategory array with full objects
        areaData.category = categoryDetails;
      }

      // console.log(areaData);
      return areaData.category;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

// Initial state
const initialState = {
  mainEuropeanWebsites: [],
  europeanWebsites: [],
  notificationsCount: null,
  loading: false,
  error: null,
};

// Slice
const websitesEuropeanSlice = createSlice({
  name: "websitesEuropean",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearNotificationsCount: (state) => {
      state.notificationsCount = null;
    },
    clearWebsites: (state) => {
      state.mainEuropeanWebsites = [];
      state.europeanWebsites = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Main European Websites
      .addCase(fetchMainEuropeanWebsites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMainEuropeanWebsites.fulfilled, (state, action) => {
        state.loading = false;
        state.mainEuropeanWebsites = action.payload;
      })
      .addCase(fetchMainEuropeanWebsites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearError, clearNotificationsCount, clearWebsites } =
  websitesEuropeanSlice.actions;
export default websitesEuropeanSlice.reducer;
